import { AZ_az_09, REGEX_MAIL, REGEX_HALF_WIDTH, MODE_EDIT, MAX_INT } from "../../../../utils/constants";
import { isNullOrEmpty, isWholeNumber } from "../../../../utils/common";
import {
    ERROR_EMPTY_LOGINID,
    ERROR_EMPTY_PASSWORD,
    ERROR_MINIMUM_LOGINID,
    ERROR_MINIMUM_PASSWORD,
    ERROR_LOGINID_PASSWORD,
    ERROR_EMPTY_BRNCHNUM,
    ERROR_EMPTY_MAINNUM,
    ERROR_EMPTY_SUPPLIERNAME,
    ERROR_CHAR_KANA,
    ERROR_EMPTY_DISP,
    ERROR_EMPTY_TEL,
    ERROR_MINMAX_BRNCHNUM,
    ERROR_MINMAX_MAINNUM,
    ERROR_ALPHANUM_LOGINID,
    ERROR_ALPHANUM_PASS,
    ERROR_CHAR_TEL,
    ERROR_CHAR_MAIL,
    ERROR_EMPTY_MAIL,
    ERROR_INVALID_BRNCHNUM,
    ERROR_INVALID_MAINNUM
} from "../../../../utils/messages";

function validate(payload) {
    let prompt = [];
    let loginIdMinLength = 8;
    let mainNumMinLength = 0;
    let mainNumMaxLength = MAX_INT;

    if (MODE_EDIT !== payload.mode) {

        if (isNullOrEmpty(payload.mainNumber)) {
            prompt.push(ERROR_EMPTY_MAINNUM);
        } else if (!isWholeNumber(payload.mainNumber)) {
            prompt.push(ERROR_INVALID_MAINNUM);
        } else if (payload.mainNumber < mainNumMinLength || payload.mainNumber > mainNumMaxLength) {
            prompt.push(ERROR_MINMAX_MAINNUM);
        }
        if (isNullOrEmpty(payload.branchNumber)) {
            prompt.push(ERROR_EMPTY_BRNCHNUM);
        } else if (!isWholeNumber(payload.branchNumber)) {
            prompt.push(ERROR_INVALID_BRNCHNUM);
        } else if (payload.branchNumber < mainNumMinLength || payload.branchNumber > mainNumMaxLength) {
            prompt.push(ERROR_MINMAX_BRNCHNUM);
        }
    }

    if (isNullOrEmpty(payload.businessPartnerName)) {
        prompt.push(ERROR_EMPTY_SUPPLIERNAME);
    }

    if (!isNullOrEmpty(payload.businessPartnerKana) && !payload.businessPartnerKana.match(REGEX_HALF_WIDTH)) {
        prompt.push(ERROR_CHAR_KANA);
    }

    if (payload.default && isNullOrEmpty(payload.email)) {
        prompt.push(ERROR_EMPTY_MAIL);
    } else if (!isNullOrEmpty(payload.email) && !payload.email.match(REGEX_MAIL)) {
        prompt.push(ERROR_CHAR_MAIL)
    }

    if (isNullOrEmpty(payload.loginId)) {
        prompt.push(ERROR_EMPTY_LOGINID);
    } else if (payload.loginId.length < loginIdMinLength) {
        prompt.push(ERROR_MINIMUM_LOGINID);
    } else if (!payload.loginId.match(AZ_az_09)) {
        prompt.push(ERROR_ALPHANUM_LOGINID)
    }

    if (isNullOrEmpty(payload.password)) {
        prompt.push(ERROR_EMPTY_PASSWORD);
    } else if (payload.password.length < loginIdMinLength) {
        prompt.push(ERROR_MINIMUM_PASSWORD);
    } else if (!payload.password.match(AZ_az_09)) {
        prompt.push(ERROR_ALPHANUM_PASS)
    } else if (!payload.default && payload.password === payload.loginId) {
        prompt.push(ERROR_LOGINID_PASSWORD)
    }

    if (isNullOrEmpty(payload.forecastValue)) {
        prompt.push(ERROR_EMPTY_DISP)
    }

    if (payload.default && isNullOrEmpty(payload.tel)) {
        prompt.push(ERROR_EMPTY_TEL);
    } else if (!isNullOrEmpty(payload.tel) && !payload.tel.match(/^[0-9- ]+$/)) {
        prompt.push(ERROR_CHAR_TEL)
    }

    return prompt;
}

export {
    validate,
};